module.exports = __webpack_public_path__ + "img/visa-electron.441c6c47.png";